import { MultiStepProductTour as _MultiStepProductTour, ProductTourDialog as _ProductTourDialog, ProductTourTooltip as _ProductTourTooltip } from '@insights-gaming/product-tour';

import { withMultiStepProductTour } from './withMultiStepProductTour';
import { withProductTour } from './withProductTour';

export const MultiStepProductTour = withProductTour(withMultiStepProductTour(_MultiStepProductTour));
export const ProductTourDialog = withProductTour(_ProductTourDialog);
export const ProductTourTooltip = withProductTour(_ProductTourTooltip);
